import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { FileService, DefaultFileHandler, FileHandlerConfiguration } from '@philips-internal/oswald-ui-components';
import { LayoutData } from '../app/types';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

class ConfigurationService {

  static getConfigurationData(): Promise<LayoutData> {
    return HttpService.get(APPLICATION_ENDPOINTS.CONFIGURATION).then(response => response.body as LayoutData);
  }

  static setFileuploaderConfig(): void {

    const config = new FileHandlerConfiguration();

    const handler = new DefaultFileHandler();
    handler.setConfiguration(config);

    FileService.setFileHandler(handler);
  }
}

export default ConfigurationService;